import styled from 'styled-components/macro';
import { HEADER_HEIGHT } from '@yme/common/constants';
import { ADAPTIVE } from '@yme/tokens/screen';
import { Z_INDEX } from '@yme/tokens/zindex';
export const ConfContainerStyled = styled.div `
  position: fixed;
  z-index: ${Z_INDEX.level8};
  width: 100%;
  margin: 0;
  top: ${HEADER_HEIGHT.sm};
  height: calc(100% - ${HEADER_HEIGHT.sm});

  ${ADAPTIVE.minWidth.tablet} {
    top: ${HEADER_HEIGHT.md};
    height: calc(100% - ${HEADER_HEIGHT.md});
  }

  ${ADAPTIVE.minWidth.desktop} {
    top: ${HEADER_HEIGHT.lg};
    height: calc(100% - ${HEADER_HEIGHT.lg});
  }

  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {
    z-index: ${Z_INDEX.popupLevel2};
    inset: 0;
    height: 100dvh;
  }
`;
